import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link FormWizardComponent}
 */
@Component({
  templateUrl: './wizard-demo.component.html',
  styleUrls: ['./wizard-demo.component.scss'],
})
export class WizardDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/form/wizard/wizard-demo.component.ts